module.exports = __webpack_public_path__ + "static/FAQ-branding-73e5816645c6569c1625fc665b308cc2.jpg";